import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const captcha: ThemeUICSSObject = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing(2),

  '.captcha__imageContainer': {
    border: '1px solid',
    borderColor: 'palette.border.field',
    p: spacing(4),
  },

  '.captcha__inputContainer': {
    display: 'flex',
    gap: spacing(2),
    justifyContent: 'stretch',

    input: {
      flexGrow: 1,
      width: '100%',
    },

    '.captcha__buttons': {
      width: '20px',
      flexDirection: 'column',
      display: 'flex',
      gap: spacing(2),
      flexShrink: 0,

      button: {
        width: '20px',
        height: '20px',
        p: '2px',
      },
    },
  },
};

export default captcha;
